import {Box, Grid, IconButton, PlusIcon, TrashIcon} from '@yandex-delivery/blocks'

import {toHeaderWidget} from '../../../../lib/to-header-widget'
import {renderWidget} from '../../../index@desktop'
import {AddressDetails} from '../Details/Address@desktop'
import {ContactDetails} from '../Details/Contact@desktop'
import * as classes from './AddressWidget@desktop.classes'
import {useAddressWidget as useAddressWidgetDesktop} from './hooks/use-address-widget'
import {useAddressWidgetProps} from './hooks/useAddressWidgetProps'
import type {Props} from './types'

export const AddressWidget: React.FC<Props> = props => {
  const {isSource, addressName, contactsName, pointId} = useAddressWidgetProps(props)
  const {addDestination, handleRemoveAddress, destinationCount, isFinalRoutePoint} = useAddressWidgetDesktop({
    routePointIndex: props.config.route_point_index,
    addressName,
    pointId,
  })

  return (
    <>
      <Grid xs={12} item>
        <Box ml="s" mt="s">
          {renderWidget(toHeaderWidget(props.config))}
          <Grid className={classes.headerButtons} justify="flex-end" size="s" container>
            {isFinalRoutePoint && (
              <Grid item>
                <IconButton onPress={addDestination} variant="ghost">
                  <PlusIcon />
                </IconButton>
              </Grid>
            )}
            {!isSource && destinationCount > 1 && (
              <Grid item>
                <IconButton onClick={handleRemoveAddress} variant="ghost">
                  <TrashIcon />
                </IconButton>
              </Grid>
            )}
          </Grid>
        </Box>
      </Grid>
      <Grid container>
        <Grid xs={12} item>
          <div className={classes.root}>
            <AddressDetails addressWidgetConfig={props.config} isSource={isSource} name={addressName} />
            <ContactDetails isSource={isSource} name={contactsName} pointId={pointId} />
          </div>
        </Grid>
      </Grid>
    </>
  )
}
